import { Inject, Injectable } from '@angular/core';
import { ADMIN_MENU_ITEMS, DEFAULT_MENU_ITEMS } from '@app/pages/pages-menu';
import { NbMenuItem } from '@nebular/theme';
import { AppConstant } from '../constants/app-constant';
import { TenantService } from '../services/tenant.service';
import { WINDOW } from './window.provider';

@Injectable()
export class TenantProvider {
    isValid: boolean;
    domain: string;
    constructor(
        private _tenantService: TenantService,
        @Inject(WINDOW) private window: Window
    ) {
        this.domain = this.window.location.hostname;
    }

    public getTenantStatus() {
        return this.isValid;
    }

    public getSubdomain() {
        let subdomain: string = '';
        if (this.domain.indexOf('.') < 0 ||
            this.domain.split('.')[0] === 'lvh' ||
            this.domain.split('.')[0] === 'www') {
            subdomain = '';
        } else {
            subdomain = this.domain.split('.')[0];
        }

        return subdomain;
    }

    public getMenuItems() {
        const subdomain = this.getSubdomain();
        let menu: NbMenuItem[];

        if (subdomain === AppConstant.AdminTenant) {
            menu = ADMIN_MENU_ITEMS
        } else {
            menu = DEFAULT_MENU_ITEMS
        }

        return menu;
    }

    load() {
        return new Promise((resolve, reject) => {
            this._tenantService.isValid().subscribe(r => {
                this.isValid = true;
                resolve(true);
            }, (err) => {
                this.isValid = false;
                resolve(true);
            });
        });
    }
}
